module.exports = __webpack_public_path__ + "static/img/JiangMei.91aef88.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/coopera/images/phone/JiangMei.png
// module id = 4zmt
// module chunks = 1